export const waitBeforeExecute = async (cb: Function, time: number) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      cb();
      resolve(true);
    }, time);
  });
};
